<!-- eslint-disable -->
<template lang="pug">
    div
        list-box
            div(slot='header')
                | {{ $i18n.t('conversations.conversations_conversationsHeader_messages') }}
            cs-button(
                color="blue"
                slot="button"
                @click="displayCreateMessageModal = true"
                v-if="user.type !== 'olympiads-student'"
            )
                | {{ $i18n.t('conversations.conversations_createMessage_messageCreating') }}
            .messages-box(slot="preview")
                .messages__menu
                    router-link.menu__item(
                        :to="{name: 'conversations'}"
                        :class="{'menu__item--current': current === 'all'}"
                    )
                        | {{ $i18n.t('conversations.conversations_conversationsMenu_all') }}
                    router-link.menu__item(
                        :to="{name: 'conversations', params: {unread: true}}"
                        :class="{'menu__item--current': current === 'unread'}"
                    )
                        | {{ $i18n.t('conversations.conversations_conversationsMenu_unread') }}
                        | ({{ amountOfUnread }})
                    router-link.menu__item(
                        :to="{name: 'messages', params: { favorite: true }}"
                        :class="{'menu__item--current': current === 'marked'}"
                    )
                        | {{ $i18n.t('conversations.conversations_conversationsMenu_marked') }}
                        | ({{ amountOfFavorites }})
                    router-link.menu__item(
                        :to="{name: 'conversations', params: {status: true}}"
                        :class="{'menu__item--current': current === 'archive'}"
                    )
                        | {{ $i18n.t('conversations.conversations_conversationsMenu_archive') }}
                .messages__body
                    .messages-box__status-selector
                        cs-multiselect(
                            :multiple="false"
                            :options="['all', 'unread', 'marked', 'archive']"
                            @input="handleStatusSelect"
                            :value="current"
                            :custom-label="statusName"
                            :placeholder="statusName(current)"
                            :hide-selected="true"
                        )
                    .messages-box__search-box
                        cs-input.messages-box__search-input(
                            type="text"
                            :placeholder="$i18n.t('conversations.conversations_conversations_searchPlaceholder')"
                            v-model="message"
                            @keyup.enter="fetchData"
                        )
                        a(href='javascript://', @click="fetchData")
                            svg-icon.messages-box__search-icon(name="search" size="large")
                    divider(:margin="'10px auto'")
                    template(v-if="!isLoading" )
                        template(v-if="messages.length > 0")
                            .messages-box__fields
                                cs-checkbox.messages-box__message-status-checkbox(v-model="allChecked")
                                .messages-box__message-statuses
                                    a.messages-box__message-status(
                                        href="javascript://"
                                        @click="uncheckChecked(true)"
                                    )
                                        | {{ $i18n.t('conversations.conversations_messages_removeMarks') }}
                            divider(:margin="'0'")
                            .messages
                                div(v-for="message in messages", :key="message.id")
                                    .message
                                        cs-checkbox(
                                            :checked="checkedMessages.find(id => message.id === id)"
                                            @change="checkMessage(conversation.id, $event)"
                                        )
                                        message(:conversation="message")
                                    divider(:margin="'0'")
                            pagination(
                                :last-page="lastPage"
                                :current-page="currentPage"
                                :total="total"
                                :length="messages.length"
                                :from="from"
                                :to="to"
                            )
                        .messages__info(v-else)
                            | {{ emptyMessage }}
                    cs-loader(v-else)
        create-message-modal(
            v-if='displayCreateMessageModal',
            @close='displayCreateMessageModal = false',
            @send='sendMessage'
        )

</template>

<script>
    /*eslint-disable*/
    import ConversationApi from '../../api/communication/conversation';
    import MessageApi from '../../api/communication/message';

    import CreateMessageModal from '../../modals/CreateMessageModal.vue';
    import ListBox from '../lists/ListBox.vue';
    import Message from './Message.vue'
    import Pagination from '../lists/Pagination.vue'

    import receiveMessage from '../../utils/communication/receiveMessage';
    import SendMessageMixin from '../../utils/communication/sendMessageMixin';

    import {mapState} from 'vuex';
    import paginate from '../../utils/paginate';
    import amountsOfMessages from '../../utils/communication/amountsOfMessages';
    import humanize from '../../utils/humanize';
    import moment from 'moment';
    import _ from 'lodash';

    export default {
        data() {
            return {
                messages: [],
                lastPage: null,
                total: null,
                currentPage: null,
                isLoading: false,
                from: null,
                to: null,
                displayCreateMessageModal: false,
                checkedMessages: [],
                allChecked: false,
                status: this.$i18n.t('conversations.conversations_conversations_archiveStatusActive'),
                message: '',
                isActive: false,
                current: 'marked',
                isAmountsLoading: false
            };
        },
        props: ['page', 'favorite', 'body'],
        mixins: [paginate, amountsOfMessages, SendMessageMixin, humanize, receiveMessage],
        components: {
            Pagination,
            Message,
            ListBox,
            CreateMessageModal,
        },
        watch: {
            '$route'() {
                this.fetchData();
            },
            allChecked(val) {
                if (val) {
                    this.messages.map(message => message.id).forEach(id => {
                        this.checkedMessages.push(id);
                    });
                    this.checkedMessages = _.uniq(this.checkedMessages);
                } else {
                    this.checkedMessages = [];
                }
            }
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
            }),
            emptyMessage () {
                switch (this.current) {
                    case 'all':
                    case 'marked':
                        return this.$i18n.t('conversations.conversations_conversations_noMessages');
                    case 'unread':
                        return this.$i18n.t('conversations.conversations_conversations_noUnreadMessages');
                    case 'archive':
                        return this.$i18n.t('conversations.conversations_conversations_noArchivedMessages');
                }
            }
        },
        mounted() {
            if (this.favorite) {
                this.current = 'marked';
            } else if (this.body) {
                this.message = this.body;
            }
            this.fetchData();

        },
        methods: {
            uncheckChecked() {
                this.isLoading = true;
                let form = {
                    messagesIds: this.checkedMessages,
                    uncheck: true
                };
                MessageApi.updateSome(form)
                .then(data => {
                    this.allChecked = false;
                    this.amountOfFavorites -= this.checkedMessages.length;
                    this.checkedMessages = [];
                    this.fetchData();
                })
            },
            fetchData() {
                this.isLoading = true;
                let form = {
                    page: this.page,
                    favorite: this.favorite,
                    body: this.message
                };
                MessageApi.list(form)
                .then((data) => {
                    this.messages = data.data;
                    this.lastPage = data.lastPage;
                    this.total = data.total;
                    this.currentPage = data.currentPage;
                    this.from = data.from;
                    this.to = data.to;
                    if (this.lastPage > 0 && this.currentPage > this.lastPage) {
                        this.currentPage = this.lastPage;
                    }
                    this.isLoading = false;
                })
                .catch((error) => {
                    this.isLoading = false;
                    this.$toasted.error(this.$root.$t('errors.getting_data'));
                });
            },
            handleStatusSelect (selector) {
                switch (selector) {
                    case 'all':
                        this.$router.push({name: 'conversations'});
                        break
                    case 'unread':
                        this.$router.push({name: 'conversations', params: {unread: true}});
                        break
                    case 'marked':
                        this.$router.push({name: 'messages', params: { favorite: true }});
                        break
                    case 'archive':
                        this.$router.push({name: 'conversations', params: {status: true}});
                        break
                }
            },
            statusName (status) {
                status = status.replace('conversations.conversations_conversationsMenu_', '');
                return this.$i18n.t(`conversations.conversations_conversationsMenu_${status}`);
            },
            checkMessage (messageId, input) {
                input
                        ? this.checkedMessages.push(messageId)
                        : (this.checkedMessages = this.checkedMessages.filter(id => id !== messageId))
            },
        }
    }
</script>

<style lang="scss" scoped>
    .messages-box {
        display: flex;
    }

    .messages__menu {
        display: none;
        @include media($xlg) {
            display: flex;
            flex-direction: column;

            font-size: 18px;
            line-height: 42px;

            min-width: 180px;
            margin-right: 30px;
        }
    }

    .menu__item {
        color: $hsl-color-blue-56;
        text-decoration: underline;
        &:hover {
            color: $hsl-color-blue-56;
            text-decoration: none;
        }
    }

    .menu__item--current {
        color: $x-color-black;
        text-decoration: none;
        &:hover {
            color: $x-color-black;
            text-decoration: none;
        }
    }

    .messages__body {
        padding: 0;
        width: 100%;
    }

    .messages-box__status-selector {
        display: flex;
        @include media($xlg) {
            display: none;
        }
    }

    .messages-box__search-box {
        margin: 9px 0 15px 0;
        display: flex;
        align-items: center;
        @include media($xlg) {
            max-width: 330px;
        }
    }

    .messages-box__search-icon {
        color: $hsl-color-blue-56;
        margin-left: 10px;
        margin-bottom: 6px;
    }

    .messages-box__fields {
        display: flex;
        padding: 0;
        margin: 30px 0;
    }

    .messages-box__message-statuses {
        display: flex;
        flex-direction: column;
        @include media($xlg) {
            flex-direction: row;
        }
    }

    .messages-box__message-status-checkbox {
        margin: 0 20px 0 0;
    }

    .messages-box__message-status {
        margin-bottom: 25px;
        display: flex;
        align-items: center;
        color: $hsl-color-blue-56;
        text-decoration: underline;
        &:hover {
            color: $hsl-color-blue-56;
            text-decoration: none;
        }
        &:last-child {
            margin: 0;
        }
        @include media($xlg) {
            margin: 0 60px 0 0;
        }
    }

    .messages-box__status-icon {
        margin-right: 10px;
    }

    .message {
        display: flex;
        align-items: center;
        margin-bottom: 0;
        background-color: transparent;
        border-radius: 0;
        font-size: medium;
        &:hover {
            background-color: $hsl-color-gray-96;
        }
    }

    .messages__info {
        margin-top: 30px;
        font-weight: 500;
        font-size: 18px;
        line-height: 21px;
        text-align: center;
    }
</style>
